<template>
  <div>
    <div v-if="user && user.email && user.is_admin">
      <v-card class="pa-5 mb-10">
        <v-card-title>
          <v-chip-group
            v-model="opened"
            active-class="primary darken-4 white--text"
            column
          >
            <v-chip>News</v-chip>
            <v-chip>Questions</v-chip>
          </v-chip-group>
        </v-card-title>
        <v-card-text>
          <div v-if="opened == 0">
            <AdminPublishNews />
          </div>
          <div v-if="opened == 1">
            <AdminPublishQuestions />
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import SendRequestMixin from "../../mixins/SendRequestMixin";

export default {
  name: "ThePublishAdmin",
  mixins: [SendRequestMixin],
  components: {
    AdminPublishNews: () => import("../forms/AdminPublishNews"),
    AdminPublishQuestions: () => import("../forms/AdminPublishQuestions")
  },
  data() {
    return {
      opened: 0
    };
  },
  computed: {
    user() {
      return this.$store.getters["loginUser"];
    }
  }
};
</script>
<style lang="sass">
.loginModal
	position: absolute
	right: 0
</style>
